const MAX_FUTURE_MS = 24 * 60 * 60 * 1000;
const MIN_SPENT_AT = Date.parse("2000-01-01T00:00:00.000Z");
const ISO_WITH_ZONE =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?(Z|[+-]\d{2}:\d{2})$/;
const LOCAL_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?$/;

const spentAtErrors = { invalid: "invalid", future: "future" };

const parseSpentAt = (value) =>
  typeof value === "string" && ISO_WITH_ZONE.test(value)
    ? Date.parse(value)
    : NaN;

const spentAtError = (value, now = Date.now()) => {
  const time = parseSpentAt(value);
  if (!Number.isFinite(time) || time < MIN_SPENT_AT) {
    return spentAtErrors.invalid;
  }
  if (time > now + MAX_FUTURE_MS) return spentAtErrors.future;
  return null;
};

const pad = (n) => String(n).padStart(2, "0");

const toDateTimeLocalValue = (value) => {
  const date = new Date(value);
  if (value == null || Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate(),
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

// Without a zone, the Date constructor reads a date-time as local time.
const fromDateTimeLocalValue = (value) => {
  if (typeof value !== "string" || !LOCAL_DATE_TIME.test(value)) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
};

const spentAtOf = (expense) =>
  expense?.spent_at ?? expense?.created_at ?? null;

module.exports = {
  MAX_FUTURE_MS,
  MIN_SPENT_AT,
  spentAtErrors,
  parseSpentAt,
  spentAtError,
  toDateTimeLocalValue,
  fromDateTimeLocalValue,
  spentAtOf,
};
